import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isLoading", "maxHeight", "maxWidth", "minHeight", "minWidth", "onClick", "role", "setInitialFocusRef", "spacing", "testId"];
import React, { useContext, useEffect } from 'react';
import { MenuGroup } from '@atlaskit/menu';
import { FocusManagerContext } from './focus-manager';

/**
 * It sets focus to the first avatar when popup is open.
 */
var PopupAvatarGroup = function PopupAvatarGroup(_ref) {
  var children = _ref.children,
    isLoading = _ref.isLoading,
    maxHeight = _ref.maxHeight,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 800 : _ref$maxWidth,
    minHeight = _ref.minHeight,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? 320 : _ref$minWidth,
    onClick = _ref.onClick,
    role = _ref.role,
    setInitialFocusRef = _ref.setInitialFocusRef,
    spacing = _ref.spacing,
    testId = _ref.testId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(FocusManagerContext),
    menuItemRefs = _useContext.menuItemRefs;
  useEffect(function () {
    setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(menuItemRefs[0]);
  }, [menuItemRefs, setInitialFocusRef]);
  return /*#__PURE__*/React.createElement(MenuGroup, _extends({
    isLoading: isLoading,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    minHeight: minHeight,
    minWidth: minWidth,
    onClick: onClick,
    role: role,
    spacing: spacing,
    testId: testId
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, rest), children);
};
export default PopupAvatarGroup;